export const Direction = {
    Departure: "Departure",
    Arrival: "Arrival"
}